import { Play, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useOnboardingTour } from "@/hooks/useOnboardingTour";
import { useTranslation } from "react-i18next";

interface OnboardingButtonProps {
  asMenuItem?: boolean;
}

export function OnboardingButton({ asMenuItem = false }: OnboardingButtonProps) {
  const { t } = useTranslation();
  const { startMainTour } = useOnboardingTour();

  const label = t('onboarding.gettingStarted', 'Getting Started');
  const tooltip = t('onboarding.tooltip', 'Take a guided tour of the app');

  if (asMenuItem) {
    return (
      <DropdownMenuItem onClick={startMainTour}>
        <Sparkles className="mr-2 h-4 w-4" />
        {label}
      </DropdownMenuItem>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" onClick={startMainTour} className="h-9 w-9">
            <Sparkles className="h-4 w-4" />
            <span className="sr-only">{label}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
